import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

import { Company } from '@/types';
    import { useForm } from '@inertiajs/vue3';
    import { useQueryClient } from '@tanstack/vue-query';
    import { useI18n } from 'vue-i18n';
    import {
        AlertDialog,
        AlertDialogTrigger,
        AlertDialogContent,
        AlertDialogHeader,
        AlertDialogTitle,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogCancel,
        AlertDialogAction,
    } from '@/components/ui/alert-dialog';
    import ActivateButton from '@/components/ActivateButton.vue';
    import DeactivateButton from '@/components/DeactivateButton.vue';
    import { computed } from 'vue';
    import { toast } from 'vue-sonner';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleActivationCompany',
  props: {
    company: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const queryClient = useQueryClient();

    const props = __props;

    const form = useForm({
        id: props.company.id,
    });

    const isDeactivated = computed(() => !!props.company.deactivated_at);

    const type = computed(() => {
        return isDeactivated.value ? 'activate' : 'deactivate';
    });

    const path = computed(() => {
        return isDeactivated.value ? 'v2.companies.activate' : 'v2.companies.deactivate';
    });

    const action = () => {
        form.post(route(path.value), {
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: [QueryKey.COMPANIES] });
                toast.success(t(`companies.js.${type.value}.success`));
            },
            onError: () => {
                toast.error(t('forms.general.error'));
            },
        });
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AlertDialog), null, {
    default: _withCtx(() => [
      _createVNode(_unref(AlertDialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          (isDeactivated.value)
            ? (_openBlock(), _createBlock(ActivateButton, {
                key: 0,
                class: "mr-auto"
              }))
            : (_openBlock(), _createBlock(DeactivateButton, {
                key: 1,
                class: "mr-auto"
              }))
        ]),
        _: 1
      }),
      _createVNode(_unref(AlertDialogContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(AlertDialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)(`companies.js.${type.value}.title`)), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogDescription), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)(`companies.js.${type.value}.content`)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(AlertDialogFooter), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogCancel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)(`companies.js.${type.value}.no`)), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogAction), {
                onClick: action,
                variant: isDeactivated.value ? 'default' : 'destructive'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)(`companies.js.${type.value}.yes`)), 1)
                ]),
                _: 1
              }, 8, ["variant"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})